import { type AgentMessage } from '@/types/agent-chat';

export type StreamableChatMessage = Pick<
  AgentMessage,
  | 'id'
  | 'sender'
  | 'content'
  | 'status'
  | 'isStreaming'
  | 'progressText'
  | 'progressEvents'
  | 'toolEvents'
> & {
  message?: string;
};

export const getStreamableMessageContent = (
  message: StreamableChatMessage
): string => message.content || message.message || '';
